import React from "react";
import { Form, Input } from "antd";

const BranchShopId = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="shopId" label="Shop ID">
      <Input showCount maxLength={6} placeholder="Shop ID" disabled={disabled} />
    </Form.Item>
  );
};

export default BranchShopId;
